{
  "$id": "city-protocol",
  "$defs": {
    "AckRequest": {
      "type": "object",
      "properties": {
        "type": {
          "$ref": "#/$defs/AckTypeEnum"
        },
        "tick": {
          "type": "integer",
          "maximum": 9007199254740991,
          "minimum": 0,
          "format": "int64"
        }
      },
      "required": ["tick", "type"]
    },
    "AckTypeEnum": {
      "enum": ["ack"],
      "type": "string",
      "description": "* `ack` - ack"
    },
    "CharacterEnum": {
      "enum": ["male", "female"],
      "type": "string",
      "description": "* `male` - male\n* `female` - female"
    },
    "ChatRequest": {
      "type": "object",
      "properties": {
        "type": {
          "$ref": "#/$defs/ChatTypeEnum"
        },
        "request_id": {
          "type": "string",
          "format": "uuid"
        },
        "text": {
          "type": "string",
          "minLength": 1,
          "maxLength": 80
        },
        "recipient": {
          "type": ["string", "null"],
          "format": "uuid"
        }
      },
      "required": ["request_id", "text", "type"]
    },
    "ChatResult": {
      "type": "object",
      "properties": {
        "type": {
          "$ref": "#/$defs/ChatResultTypeEnum"
        },
        "request_id": {
          "type": "string",
          "format": "uuid"
        },
        "status": {
          "$ref": "#/$defs/ChatResultStatusEnum"
        },
        "speaker": {
          "$ref": "#/$defs/Visitor"
        }
      },
      "required": ["request_id", "speaker", "status", "type"]
    },
    "ChatResultStatusEnum": {
      "enum": ["sent", "wait", "unavailable"],
      "type": "string",
      "description": "* `sent` - sent\n* `wait` - wait\n* `unavailable` - unavailable"
    },
    "ChatResultTypeEnum": {
      "enum": ["chat_result"],
      "type": "string",
      "description": "* `chat_result` - chat_result"
    },
    "ChatTypeEnum": {
      "enum": ["chat"],
      "type": "string",
      "description": "* `chat` - chat"
    },
    "ClothingEnum": {
      "enum": ["russet", "woad", "madder", "green", "weld", "black"],
      "type": "string",
      "description": "* `russet` - russet\n* `woad` - woad\n* `madder` - madder\n* `green` - green\n* `weld` - weld\n* `black` - black"
    },
    "ConnectionRequestRequest": {
      "type": "object",
      "properties": {
        "client_id": {
          "type": "string",
          "format": "uuid"
        },
        "world_version": {
          "type": "string",
          "minLength": 64,
          "maxLength": 64
        },
        "seed": {
          "type": "integer",
          "minimum": 0
        },
        "pose": {
          "$ref": "#/$defs/PoseRequest"
        }
      },
      "required": ["client_id", "pose", "seed", "world_version"]
    },
    "ConnectionResponse": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "format": "uuid"
        },
        "ticket": {
          "type": "string"
        },
        "websocket_path": {
          "type": "string"
        },
        "protocol": {
          "type": "string"
        }
      },
      "required": ["id", "protocol", "ticket", "websocket_path"]
    },
    "Discovery": {
      "type": "object",
      "properties": {
        "place": {
          "$ref": "#/$defs/PlaceEnum"
        },
        "found_at": {
          "type": "string",
          "format": "date-time",
          "readOnly": true
        }
      },
      "required": ["found_at", "place"]
    },
    "DiscoveryRequest": {
      "type": "object",
      "properties": {
        "place": {
          "$ref": "#/$defs/PlaceEnum"
        }
      },
      "required": ["place"]
    },
    "EmoteNameEnum": {
      "enum": ["wave", "curtsy", "bow", "heelclick", "hatsoff", "mlady", "avast"],
      "type": "string",
      "description": "* `wave` - wave\n* `curtsy` - curtsy\n* `bow` - bow\n* `heelclick` - heelclick\n* `hatsoff` - hatsoff\n* `mlady` - mlady\n* `avast` - avast"
    },
    "EmoteRequest": {
      "type": "object",
      "properties": {
        "type": {
          "$ref": "#/$defs/EmoteTypeEnum"
        },
        "request_id": {
          "type": "string",
          "format": "uuid"
        },
        "name": {
          "$ref": "#/$defs/EmoteNameEnum"
        }
      },
      "required": ["name", "request_id", "type"]
    },
    "EmoteResult": {
      "type": "object",
      "properties": {
        "type": {
          "$ref": "#/$defs/EmoteResultTypeEnum"
        },
        "request_id": {
          "type": "string",
          "format": "uuid"
        },
        "status": {
          "$ref": "#/$defs/EmoteResultStatusEnum"
        },
        "emote": {
          "oneOf": [
            {
              "$ref": "#/$defs/Gesture"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": ["emote", "request_id", "status", "type"]
    },
    "EmoteResultStatusEnum": {
      "enum": ["started", "busy", "unavailable"],
      "type": "string",
      "description": "* `started` - started\n* `busy` - busy\n* `unavailable` - unavailable"
    },
    "EmoteResultTypeEnum": {
      "enum": ["emote_result"],
      "type": "string",
      "description": "* `emote_result` - emote_result"
    },
    "EmoteTypeEnum": {
      "enum": ["emote"],
      "type": "string",
      "description": "* `emote` - emote"
    },
    "Error": {
      "type": "object",
      "properties": {
        "detail": {
          "type": "string"
        }
      },
      "required": ["detail"]
    },
    "Gesture": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "format": "uuid"
        },
        "name": {
          "$ref": "#/$defs/EmoteNameEnum"
        },
        "started_at_ms": {
          "type": "number",
          "format": "double"
        },
        "duration_ms": {
          "type": "integer",
          "minimum": 1
        }
      },
      "required": ["duration_ms", "id", "name", "started_at_ms"]
    },
    "Health": {
      "type": "object",
      "properties": {
        "ready": {
          "type": "boolean"
        },
        "database": {
          "type": "boolean"
        },
        "redis": {
          "type": "boolean"
        },
        "simulation": {
          "type": "boolean"
        }
      },
      "required": ["database", "ready", "redis", "simulation"]
    },
    "KindEnum": {
      "enum": ["say", "whisper"],
      "type": "string",
      "description": "* `say` - say\n* `whisper` - whisper"
    },
    "ModeEnum": {
      "enum": ["walk", "boat"],
      "type": "string",
      "description": "* `walk` - walk\n* `boat` - boat"
    },
    "MuteRequest": {
      "type": "object",
      "properties": {
        "type": {
          "$ref": "#/$defs/MuteTypeEnum"
        },
        "request_id": {
          "type": "string",
          "format": "uuid"
        },
        "target": {
          "type": "string",
          "format": "uuid"
        },
        "muted": {
          "type": "boolean"
        }
      },
      "required": ["muted", "request_id", "target", "type"]
    },
    "MuteResult": {
      "type": "object",
      "properties": {
        "type": {
          "$ref": "#/$defs/MuteResultTypeEnum"
        },
        "request_id": {
          "type": "string",
          "format": "uuid"
        },
        "target": {
          "type": "string",
          "format": "uuid"
        },
        "muted": {
          "type": "boolean"
        },
        "status": {
          "$ref": "#/$defs/MuteResultStatusEnum"
        }
      },
      "required": ["muted", "request_id", "status", "target", "type"]
    },
    "MuteResultStatusEnum": {
      "enum": ["applied", "unavailable"],
      "type": "string",
      "description": "* `applied` - applied\n* `unavailable` - unavailable"
    },
    "MuteResultTypeEnum": {
      "enum": ["mute_result"],
      "type": "string",
      "description": "* `mute_result` - mute_result"
    },
    "MuteTypeEnum": {
      "enum": ["mute"],
      "type": "string",
      "description": "* `mute` - mute"
    },
    "NameEnum": {
      "enum": [
        "Jan Claesz de Dove",
        "Dirck Pietersz Halfhout",
        "Willem Gielisz Bierkan",
        "Heyn Jacobsz Coppen",
        "Cornelis Woutersz Taai",
        "Claes Jansz Rooneus",
        "Pieter Dircxz Lange",
        "Gielis Heynsz Scheel",
        "Wouter Claesz Vettebroot",
        "Jacob Cornelisz Mager",
        "Jan Jansz Snoeck",
        "Dirc Willemsz Stoter",
        "Henric Pietersz Mortel",
        "Claes Dircxz Kreupel",
        "Willem Jansz Haerinck",
        "Pieter Claesz Corte",
        "Cornelis Jacobsz Gulsigh",
        "Jan Gielisz Buyck",
        "Gielis Woutersz Muys",
        "Dirck Heynsz Clappaert",
        "Wouter Jansz Slaperigh",
        "Jacob Pietersz Hoorendrager",
        "Jan Dircxz Botermont",
        "Heyn Cornelisz Tantlooss",
        "Claes Willemsz Zuyper",
        "Pieter Jacobsz Spoock",
        "Dirc Claesz Brouwer",
        "Willem Cornelisz Mal",
        "Jan Heynsz Wijnzack",
        "Cornelis Gielisz Knorre",
        "Gielis Jansz Ganssneus",
        "Jacob Dircxz Lamme",
        "Wouter Pietersz Gaeper",
        "Claes Heynsz Kael",
        "Pieter Woutersz Swijgher",
        "Henric Claesz Bulderaer",
        "Dirck Jacobsz Kaesboer",
        "Jan Cornelisz Goetsmoets",
        "Willem Heynsz Luy",
        "Cornelis Claesz Scheefbeen",
        "Jacob Jansz Eelvanger",
        "Gielis Pietersz Pottekijker",
        "Jan Woutersz Clompe",
        "Claes Gielisz Dickhooft",
        "Pieter Heynsz Rammelaer",
        "Dirc Gielisz Hollebolle",
        "Wouter Dircxz Ongecamt",
        "Heyn Willemsz Proever",
        "Jan Jacobsz Sonder Gelt",
        "Cornelis Pietersz Nimmernuchter",
        "Jacob Claesz Bonsel",
        "Maria Jansdr de Kijfster",
        "Alijt Claesdr Snatersmont",
        "Lijsbeth Dircxdr Rapp",
        "Margriet Pietersdr Lange",
        "Katrijn Willemsdr Scherp",
        "Anna Cornelisdr Tantloos",
        "Neeltje Jacobsdr Vet",
        "Geertruijt Heynsdr Kael",
        "Trijn Gielisdr Waschvrou",
        "Maritgen Woutersdr Gluurster",
        "Aleid Jansdr Brouwster",
        "Lisebette Claesdr Taai",
        "Margareta Dircxdr Hooch",
        "Catharina Pietersdr Coppen",
        "Anne Willemsdr Stille",
        "Neel Cornelisdr Corte",
        "Giertje Jacobsdr Melckmeyt",
        "Maria Heynsdr Gulsigh",
        "Alijt Gielisdr Haeringwijf",
        "Lijsbeth Woutersdr Cramer",
        "Katrijn Jansdr Scheel",
        "Trijn Claesdr Bulderaer",
        "Anna Dircxdr Zuypster",
        "Margriet Cornelisdr Kreupel",
        "Neeltje Pietersdr Mager",
        "Geertruijt Willemsdr Kaeskop",
        "Aleydis Jacobsdr Spoock",
        "Maritgen Heynsdr Rooneus",
        "Lisebette Gielisdr Luy",
        "Catharina Woutersdr Klappei",
        "Maria Claesdr Sonder Man",
        "Anne Jansdr Botermont",
        "Trijn Dircxdr Ongecamt",
        "Neel Jacobsdr Snoeck",
        "Giertje Cornelisdr Dove",
        "Margareta Heynsdr Buyck",
        "Alijt Pietersdr Lamme",
        "Lijsbeth Willemsdr Hollebolle",
        "Katrijn Gielisdr Nimmerstil"
      ],
      "type": "string",
      "description": "* `Jan Claesz de Dove` - Jan Claesz de Dove\n* `Dirck Pietersz Halfhout` - Dirck Pietersz Halfhout\n* `Willem Gielisz Bierkan` - Willem Gielisz Bierkan\n* `Heyn Jacobsz Coppen` - Heyn Jacobsz Coppen\n* `Cornelis Woutersz Taai` - Cornelis Woutersz Taai\n* `Claes Jansz Rooneus` - Claes Jansz Rooneus\n* `Pieter Dircxz Lange` - Pieter Dircxz Lange\n* `Gielis Heynsz Scheel` - Gielis Heynsz Scheel\n* `Wouter Claesz Vettebroot` - Wouter Claesz Vettebroot\n* `Jacob Cornelisz Mager` - Jacob Cornelisz Mager\n* `Jan Jansz Snoeck` - Jan Jansz Snoeck\n* `Dirc Willemsz Stoter` - Dirc Willemsz Stoter\n* `Henric Pietersz Mortel` - Henric Pietersz Mortel\n* `Claes Dircxz Kreupel` - Claes Dircxz Kreupel\n* `Willem Jansz Haerinck` - Willem Jansz Haerinck\n* `Pieter Claesz Corte` - Pieter Claesz Corte\n* `Cornelis Jacobsz Gulsigh` - Cornelis Jacobsz Gulsigh\n* `Jan Gielisz Buyck` - Jan Gielisz Buyck\n* `Gielis Woutersz Muys` - Gielis Woutersz Muys\n* `Dirck Heynsz Clappaert` - Dirck Heynsz Clappaert\n* `Wouter Jansz Slaperigh` - Wouter Jansz Slaperigh\n* `Jacob Pietersz Hoorendrager` - Jacob Pietersz Hoorendrager\n* `Jan Dircxz Botermont` - Jan Dircxz Botermont\n* `Heyn Cornelisz Tantlooss` - Heyn Cornelisz Tantlooss\n* `Claes Willemsz Zuyper` - Claes Willemsz Zuyper\n* `Pieter Jacobsz Spoock` - Pieter Jacobsz Spoock\n* `Dirc Claesz Brouwer` - Dirc Claesz Brouwer\n* `Willem Cornelisz Mal` - Willem Cornelisz Mal\n* `Jan Heynsz Wijnzack` - Jan Heynsz Wijnzack\n* `Cornelis Gielisz Knorre` - Cornelis Gielisz Knorre\n* `Gielis Jansz Ganssneus` - Gielis Jansz Ganssneus\n* `Jacob Dircxz Lamme` - Jacob Dircxz Lamme\n* `Wouter Pietersz Gaeper` - Wouter Pietersz Gaeper\n* `Claes Heynsz Kael` - Claes Heynsz Kael\n* `Pieter Woutersz Swijgher` - Pieter Woutersz Swijgher\n* `Henric Claesz Bulderaer` - Henric Claesz Bulderaer\n* `Dirck Jacobsz Kaesboer` - Dirck Jacobsz Kaesboer\n* `Jan Cornelisz Goetsmoets` - Jan Cornelisz Goetsmoets\n* `Willem Heynsz Luy` - Willem Heynsz Luy\n* `Cornelis Claesz Scheefbeen` - Cornelis Claesz Scheefbeen\n* `Jacob Jansz Eelvanger` - Jacob Jansz Eelvanger\n* `Gielis Pietersz Pottekijker` - Gielis Pietersz Pottekijker\n* `Jan Woutersz Clompe` - Jan Woutersz Clompe\n* `Claes Gielisz Dickhooft` - Claes Gielisz Dickhooft\n* `Pieter Heynsz Rammelaer` - Pieter Heynsz Rammelaer\n* `Dirc Gielisz Hollebolle` - Dirc Gielisz Hollebolle\n* `Wouter Dircxz Ongecamt` - Wouter Dircxz Ongecamt\n* `Heyn Willemsz Proever` - Heyn Willemsz Proever\n* `Jan Jacobsz Sonder Gelt` - Jan Jacobsz Sonder Gelt\n* `Cornelis Pietersz Nimmernuchter` - Cornelis Pietersz Nimmernuchter\n* `Jacob Claesz Bonsel` - Jacob Claesz Bonsel\n* `Maria Jansdr de Kijfster` - Maria Jansdr de Kijfster\n* `Alijt Claesdr Snatersmont` - Alijt Claesdr Snatersmont\n* `Lijsbeth Dircxdr Rapp` - Lijsbeth Dircxdr Rapp\n* `Margriet Pietersdr Lange` - Margriet Pietersdr Lange\n* `Katrijn Willemsdr Scherp` - Katrijn Willemsdr Scherp\n* `Anna Cornelisdr Tantloos` - Anna Cornelisdr Tantloos\n* `Neeltje Jacobsdr Vet` - Neeltje Jacobsdr Vet\n* `Geertruijt Heynsdr Kael` - Geertruijt Heynsdr Kael\n* `Trijn Gielisdr Waschvrou` - Trijn Gielisdr Waschvrou\n* `Maritgen Woutersdr Gluurster` - Maritgen Woutersdr Gluurster\n* `Aleid Jansdr Brouwster` - Aleid Jansdr Brouwster\n* `Lisebette Claesdr Taai` - Lisebette Claesdr Taai\n* `Margareta Dircxdr Hooch` - Margareta Dircxdr Hooch\n* `Catharina Pietersdr Coppen` - Catharina Pietersdr Coppen\n* `Anne Willemsdr Stille` - Anne Willemsdr Stille\n* `Neel Cornelisdr Corte` - Neel Cornelisdr Corte\n* `Giertje Jacobsdr Melckmeyt` - Giertje Jacobsdr Melckmeyt\n* `Maria Heynsdr Gulsigh` - Maria Heynsdr Gulsigh\n* `Alijt Gielisdr Haeringwijf` - Alijt Gielisdr Haeringwijf\n* `Lijsbeth Woutersdr Cramer` - Lijsbeth Woutersdr Cramer\n* `Katrijn Jansdr Scheel` - Katrijn Jansdr Scheel\n* `Trijn Claesdr Bulderaer` - Trijn Claesdr Bulderaer\n* `Anna Dircxdr Zuypster` - Anna Dircxdr Zuypster\n* `Margriet Cornelisdr Kreupel` - Margriet Cornelisdr Kreupel\n* `Neeltje Pietersdr Mager` - Neeltje Pietersdr Mager\n* `Geertruijt Willemsdr Kaeskop` - Geertruijt Willemsdr Kaeskop\n* `Aleydis Jacobsdr Spoock` - Aleydis Jacobsdr Spoock\n* `Maritgen Heynsdr Rooneus` - Maritgen Heynsdr Rooneus\n* `Lisebette Gielisdr Luy` - Lisebette Gielisdr Luy\n* `Catharina Woutersdr Klappei` - Catharina Woutersdr Klappei\n* `Maria Claesdr Sonder Man` - Maria Claesdr Sonder Man\n* `Anne Jansdr Botermont` - Anne Jansdr Botermont\n* `Trijn Dircxdr Ongecamt` - Trijn Dircxdr Ongecamt\n* `Neel Jacobsdr Snoeck` - Neel Jacobsdr Snoeck\n* `Giertje Cornelisdr Dove` - Giertje Cornelisdr Dove\n* `Margareta Heynsdr Buyck` - Margareta Heynsdr Buyck\n* `Alijt Pietersdr Lamme` - Alijt Pietersdr Lamme\n* `Lijsbeth Willemsdr Hollebolle` - Lijsbeth Willemsdr Hollebolle\n* `Katrijn Gielisdr Nimmerstil` - Katrijn Gielisdr Nimmerstil"
    },
    "PingRequest": {
      "type": "object",
      "properties": {
        "type": {
          "$ref": "#/$defs/PingTypeEnum"
        },
        "client_ms": {
          "type": "number",
          "format": "double",
          "maximum": 1000000000000000,
          "minimum": 0
        }
      },
      "required": ["client_ms", "type"]
    },
    "PingTypeEnum": {
      "enum": ["ping"],
      "type": "string",
      "description": "* `ping` - ping"
    },
    "PlaceEnum": {
      "enum": [
        "landmark-waag-dam",
        "landmark-vismarkt",
        "landmark-dam",
        "landmark-scheepskraan",
        "landmark-lijnbaan-boom",
        "landmark-lakenramen",
        "landmark-lucienerf-carpenter",
        "landmark-scafferij-baerdsehuys",
        "landmark-oude-stadhuis",
        "landmark-sint-olofspoort",
        "landmark-kolk-gate",
        "landmark-nieuwe-brug-west-tower",
        "landmark-nieuwe-brug-blockhouse",
        "landmark-blokhuis-boom-west",
        "landmark-handboogdoelen",
        "landmark-voetboogdoelen",
        "landmark-oude-kerk",
        "landmark-nieuwe-kerk",
        "landmark-heilige-stede",
        "landmark-begijnhofkapel",
        "landmark-sint-pietersgasthuis",
        "landmark-eerste-weeshuis",
        "landmark-leprozenhuis",
        "landmark-kartuizerklooster"
      ],
      "type": "string",
      "description": "* `landmark-waag-dam` - landmark-waag-dam\n* `landmark-vismarkt` - landmark-vismarkt\n* `landmark-dam` - landmark-dam\n* `landmark-scheepskraan` - landmark-scheepskraan\n* `landmark-lijnbaan-boom` - landmark-lijnbaan-boom\n* `landmark-lakenramen` - landmark-lakenramen\n* `landmark-lucienerf-carpenter` - landmark-lucienerf-carpenter\n* `landmark-scafferij-baerdsehuys` - landmark-scafferij-baerdsehuys\n* `landmark-oude-stadhuis` - landmark-oude-stadhuis\n* `landmark-sint-olofspoort` - landmark-sint-olofspoort\n* `landmark-kolk-gate` - landmark-kolk-gate\n* `landmark-nieuwe-brug-west-tower` - landmark-nieuwe-brug-west-tower\n* `landmark-nieuwe-brug-blockhouse` - landmark-nieuwe-brug-blockhouse\n* `landmark-blokhuis-boom-west` - landmark-blokhuis-boom-west\n* `landmark-handboogdoelen` - landmark-handboogdoelen\n* `landmark-voetboogdoelen` - landmark-voetboogdoelen\n* `landmark-oude-kerk` - landmark-oude-kerk\n* `landmark-nieuwe-kerk` - landmark-nieuwe-kerk\n* `landmark-heilige-stede` - landmark-heilige-stede\n* `landmark-begijnhofkapel` - landmark-begijnhofkapel\n* `landmark-sint-pietersgasthuis` - landmark-sint-pietersgasthuis\n* `landmark-eerste-weeshuis` - landmark-eerste-weeshuis\n* `landmark-leprozenhuis` - landmark-leprozenhuis\n* `landmark-kartuizerklooster` - landmark-kartuizerklooster"
    },
    "Pong": {
      "type": "object",
      "properties": {
        "type": {
          "$ref": "#/$defs/PongTypeEnum"
        },
        "client_ms": {
          "type": "number",
          "format": "double"
        },
        "server_epoch_ms": {
          "type": "number",
          "format": "double"
        }
      },
      "required": ["client_ms", "server_epoch_ms", "type"]
    },
    "PongTypeEnum": {
      "enum": ["pong"],
      "type": "string",
      "description": "* `pong` - pong"
    },
    "PoseRequest": {
      "type": "object",
      "properties": {
        "type": {
          "$ref": "#/$defs/PoseTypeEnum"
        },
        "seq": {
          "type": "integer",
          "maximum": 2147483647,
          "minimum": 0
        },
        "x": {
          "type": "number",
          "format": "double",
          "maximum": 22500,
          "minimum": -22500
        },
        "y": {
          "type": "number",
          "format": "double",
          "maximum": 45000,
          "minimum": -5
        },
        "z": {
          "type": "number",
          "format": "double",
          "maximum": 22500,
          "minimum": -22500
        },
        "yaw": {
          "type": "number",
          "format": "double"
        },
        "mode": {
          "$ref": "#/$defs/ModeEnum"
        },
        "character": {
          "allOf": [
            {
              "$ref": "#/$defs/CharacterEnum"
            }
          ],
          "default": "male"
        },
        "name": {
          "$ref": "#/$defs/NameEnum"
        },
        "clothing": {
          "allOf": [
            {
              "$ref": "#/$defs/ClothingEnum"
            }
          ],
          "default": "russet"
        }
      },
      "required": ["mode", "seq", "type", "x", "y", "yaw", "z"]
    },
    "PoseTypeEnum": {
      "enum": ["pose"],
      "type": "string",
      "description": "* `pose` - pose"
    },
    "Snapshot": {
      "type": "object",
      "properties": {
        "type": {
          "$ref": "#/$defs/SnapshotTypeEnum"
        },
        "generation": {
          "type": "string",
          "format": "uuid"
        },
        "world_version": {
          "type": "string"
        },
        "server_epoch_ms": {
          "type": "number",
          "format": "double"
        },
        "city_epoch_ms": {
          "type": "number",
          "format": "double"
        },
        "animation_seconds": {
          "type": "number",
          "format": "double"
        },
        "tick": {
          "type": "integer"
        },
        "count": {
          "type": "integer"
        },
        "players": {
          "type": "array",
          "items": {
            "$ref": "#/$defs/Visitor"
          }
        }
      },
      "required": [
        "animation_seconds",
        "city_epoch_ms",
        "count",
        "generation",
        "players",
        "server_epoch_ms",
        "tick",
        "type",
        "world_version"
      ]
    },
    "SnapshotTypeEnum": {
      "enum": ["snapshot"],
      "type": "string",
      "description": "* `snapshot` - snapshot"
    },
    "Speech": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "format": "uuid"
        },
        "text": {
          "type": "string",
          "maxLength": 80
        },
        "created_at_ms": {
          "type": "number",
          "format": "double"
        },
        "kind": {
          "$ref": "#/$defs/KindEnum"
        }
      },
      "required": ["created_at_ms", "id", "kind", "text"]
    },
    "SpeechDelivery": {
      "type": "object",
      "properties": {
        "type": {
          "$ref": "#/$defs/SpeechDeliveryTypeEnum"
        },
        "generation": {
          "type": "string",
          "format": "uuid"
        },
        "speaker": {
          "$ref": "#/$defs/Visitor"
        }
      },
      "required": ["generation", "speaker", "type"]
    },
    "SpeechDeliveryTypeEnum": {
      "enum": ["speech"],
      "type": "string",
      "description": "* `speech` - speech"
    },
    "Visitor": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "format": "uuid"
        },
        "seq": {
          "type": "integer"
        },
        "x": {
          "type": "number",
          "format": "double"
        },
        "y": {
          "type": "number",
          "format": "double"
        },
        "z": {
          "type": "number",
          "format": "double"
        },
        "yaw": {
          "type": "number",
          "format": "double"
        },
        "mode": {
          "$ref": "#/$defs/ModeEnum"
        },
        "character": {
          "$ref": "#/$defs/CharacterEnum"
        },
        "name": {
          "$ref": "#/$defs/NameEnum"
        },
        "clothing": {
          "$ref": "#/$defs/ClothingEnum"
        },
        "speech": {
          "oneOf": [
            {
              "$ref": "#/$defs/Speech"
            },
            {
              "type": "null"
            }
          ]
        },
        "emote": {
          "oneOf": [
            {
              "$ref": "#/$defs/Gesture"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "character",
        "clothing",
        "id",
        "mode",
        "name",
        "seq",
        "speech",
        "x",
        "y",
        "yaw",
        "z"
      ]
    },
    "World": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "format": "uuid",
          "readOnly": true
        },
        "slug": {
          "type": "string",
          "readOnly": true,
          "pattern": "^[-a-zA-Z0-9_]+$"
        },
        "name": {
          "type": "string",
          "readOnly": true
        },
        "seed": {
          "type": "integer",
          "readOnly": true
        },
        "asset_version": {
          "type": "string",
          "readOnly": true
        },
        "epoch": {
          "type": "string",
          "format": "date-time",
          "readOnly": true
        },
        "clock_offset_minutes": {
          "type": "number",
          "format": "double",
          "readOnly": true
        },
        "requires_account": {
          "type": "boolean",
          "readOnly": true
        }
      },
      "required": [
        "asset_version",
        "clock_offset_minutes",
        "epoch",
        "id",
        "name",
        "requires_account",
        "seed",
        "slug"
      ]
    }
  }
}
